<template>
  <div class="controlpanel">
    <!--空调 控制面板 -->
    <div class="con">
      <div class="left-tree">
        <el-input
          placeholder="请输入房间号"
          v-model="filterText"
          style="margin-bottom:8px"
        >
        </el-input>
        <el-scrollbar style="height:calc(100% - 30px);width: 100%;">
          <el-tree
            class="filter-tree"
            :data="treeDataList"
            node-key="id"
            :props="defaultProps"
            :highlight-current="true"
            :filter-node-method="filterNode"
            ref="tree2"
            default-expand-all
            :default-expanded-keys="['001']"
            :default-checked-keys="[101]"
            show-checkbox
            @node-click="topnodeClick"
          >
            <template slot-scope="{ node }">
              <span class="custom-tree-node" style="font-size:14px">
                <img
                  src="../../../public/static/image/elTree/1.9.png"
                  v-show="node.data.type == 'jianzhu'"
                />
                <img
                  src="../../../public/static/image/elTree/2.4.png"
                  v-show="node.data.type == 'shebei'"
                />
                <span style="margin-left:4px">{{ node.label }}</span>
              </span>
            </template>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="right-con">
        <div class="topsearch">
          <el-button type="primary" plain @click="allchoicefn">{{
            allchoice ? "取消全选" : "全选"
          }}</el-button>
          <el-select
            v-model="valuename"
            placeholder="请选择空调状态"
            style="width:280px"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="primary" style="margin-left:12px">搜索</el-button>
          <el-button type="primary" icon="el-icon-refresh" plain
            >重置</el-button
          >
        </div>
        <div class="middlecon">
          <div :class="['middlecard', { middlecardactive: isTreeShow }]">
            <el-scrollbar style="height:calc(100% - 5px);width: 100%;">
              <div class="middlecarddiv">
                <div
                  class="carditem"
                  v-for="item in middleData"
                  :key="item.name"
                >
                  <img
                    src="../../assets/airConditioner/kongtiao1.png"
                    alt=""
                    class="img1"
                  />
                  <img
                    src="../../assets/airConditioner/kongtiao2.png"
                    alt=""
                    class="img2"
                  />
                  <img
                    src="../../assets/airConditioner/kongtiao3.png"
                    alt=""
                    class="img3"
                  />
                  <img
                    src="../../assets/airConditioner/kongtiao4.png"
                    alt=""
                    class="img4"
                  />
                  <div :class="['itemtop', { topactive: item.checked }]">
                    <el-checkbox v-model="item.checked" @change="changCheck">{{
                      item.name
                    }}</el-checkbox>
                    <img
                      src="../../assets/airConditioner/wifi.png"
                      alt=""
                      class="img5"
                    />
                  </div>
                  <div class="itemcon" @click="clickCheckFn(item)">
                    <div class="leftyibiaopan">
                      <el-progress
                        type="dashboard"
                        :percentage="percentage"
                        :color="colors"
                        :show-text="false"
                      ></el-progress>
                      <div class="context">
                        <p>室温 28°C</p>
                        <div class="num2">26 <span>°C</span></div>
                      </div>
                    </div>
                    <div class="threeimg">
                      <div>
                        <div class="threeitem">
                          <img
                            src="../../assets/airConditioner/zhilen.png"
                            alt=""
                          />制冷
                        </div>
                        <div class="threeitem">
                          <img
                            src="../../assets/airConditioner/zhongfeng.png"
                            alt=""
                          />中风
                        </div>
                        <div class="threeitem" style="margin-bottom: 0px;">
                          <img
                            src="../../assets/airConditioner/guanji.png"
                            alt=""
                          />关机
                          <img
                            src="../../assets/airConditioner/kaiji.png"
                            alt=""
                            style="margin-left:5px;margin-right:0px"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="itembottom" @click="clickCheckFn(item)">
                    <img
                      src="../../assets/airConditioner/touxiang.png"
                      alt=""
                    />
                    租户：{{ item.name }}
                  </div>
                  <div
                    class="mymask"
                    v-show="item.checked"
                    @click="clickCheckFn(item)"
                  ></div>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div :class="['middledrawer', { draweractive: isTreeShow }]">
            <div
              :class="['elescoping', { 'active-img': isTreeShow }]"
              @click="isTreeShow = !isTreeShow"
            >
              <img
                src="../../assets/unifyImg/contract.png"
                v-show="isTreeShow"
              />
              <img
                src="../..//assets/unifyImg/expand2.png"
                v-show="!isTreeShow"
              />
            </div>
            <div class="drawertitle">
              <div class="leftname">
                <span class="lines"></span>
                状态控制
              </div>
              <div class="rightbtn">生效</div>
            </div>
            <div class="kaiguan">
              开关
              <el-switch
                v-model="value"
                active-color="#368ed9"
                inactive-color="#dcdfe6"
              >
              </el-switch>
            </div>
            <div class="kaiguan">
              温度
              <div class="huakuai">
                <el-slider v-model="value1"></el-slider>
              </div>
              <div class="wendunum">16 <span>°C</span></div>
            </div>
            <div class="moshi" style="margin-top:12px">
              <div class="moshiitem" @click="moshinum = 1">
                <div>
                  <img
                    src="../../assets/airConditioner/zhire1.png"
                    alt=""
                    v-show="moshinum != 1"
                  />
                  <img
                    src="../../assets/airConditioner/zhire2.png"
                    alt=""
                    v-show="moshinum == 1"
                  />
                  <p :class="{ zhireactive: moshinum == 1 }">制热</p>
                </div>
              </div>
              <div class="moshiitem" @click="moshinum = 2">
                <div>
                  <img
                    src="../../assets/airConditioner/zhilen1.png"
                    alt=""
                    v-show="moshinum != 2"
                  />
                  <img
                    src="../../assets/airConditioner/zhilen2.png"
                    alt=""
                    v-show="moshinum == 2"
                  />
                  <p :class="{ zhilencative: moshinum == 2 }">制冷</p>
                </div>
              </div>
              <div class="moshiitem" @click="moshinum = 3">
                <div>
                  <img
                    src="../../assets/airConditioner/chushi1.png"
                    alt=""
                    v-show="moshinum != 3"
                  />
                  <img
                    src="../../assets/airConditioner/chushi2.png"
                    alt=""
                    v-show="moshinum == 3"
                  />
                  <p :class="{ chushiactive: moshinum == 3 }">除湿</p>
                </div>
              </div>
              <div class="moshiitem" @click="moshinum = 4">
                <div>
                  <img
                    src="../../assets/airConditioner/nifeng1.png"
                    alt=""
                    v-show="moshinum != 4"
                  />
                  <img
                    src="../../assets/airConditioner/nifeng2.png"
                    alt=""
                    v-show="moshinum == 4"
                  />
                  <p :class="{ songfengactive: moshinum == 4 }">逆风</p>
                </div>
              </div>
            </div>
            <div class="moshi fengsu" style="margin-top:12px">
              <div class="moshiitem" @click="moshinumfeng = 1">
                <div>
                  <img
                    src="../../assets/airConditioner/gaofeng1.png"
                    alt=""
                    v-show="moshinumfeng != 1"
                  />
                  <img
                    src="../../assets/airConditioner/gaofeng2.png"
                    alt=""
                    v-show="moshinumfeng == 1"
                  />
                  <p :class="{ zhilencative: moshinumfeng == 1 }">高风</p>
                </div>
              </div>
              <div class="moshiitem" @click="moshinumfeng = 2">
                <div>
                  <img
                    src="../../assets/airConditioner/zhongfeng1.png"
                    alt=""
                    v-show="moshinumfeng != 2"
                  />
                  <img
                    src="../../assets/airConditioner/zhongfeng2.png"
                    alt=""
                    v-show="moshinumfeng == 2"
                  />
                  <p :class="{ zhilencative: moshinumfeng == 2 }">中风</p>
                </div>
              </div>
              <div class="moshiitem" @click="moshinumfeng = 3">
                <div>
                  <img
                    src="../../assets/airConditioner/difeng1.png"
                    alt=""
                    v-show="moshinumfeng != 3"
                  />
                  <img
                    src="../../assets/airConditioner/difeng2.png"
                    alt=""
                    v-show="moshinumfeng == 3"
                  />
                  <p :class="{ zhilencative: moshinumfeng == 3 }">低风</p>
                </div>
              </div>
            </div>
            <div class="drawertitle">
              <div class="leftname">
                <span class="lines"></span>
                锁定控制
              </div>
              <div class="zhenrigjt">
                <div class="rightbtn jiesuo">解锁</div>
                <div class="rightbtn">生效</div>
              </div>
            </div>
            <div class="tongyongdiv">
              <div class="tips">温度上限</div>
              <div class="mychecked">
                <el-checkbox v-model="suoding1"></el-checkbox>
              </div>
              <div class="miaoshu">锁定</div>
              <div class="huakuai">
                <el-slider v-model="value2"></el-slider>
              </div>
              <div class="wendubox">31°C</div>
            </div>
            <div class="tongyongdiv">
              <div class="tips">温度下限</div>
              <div class="mychecked">
                <el-checkbox v-model="suoding2"></el-checkbox>
              </div>
              <div class="miaoshu">锁定</div>
              <div class="huakuai">
                <el-slider v-model="value3"></el-slider>
              </div>
              <div class="wendubox">16°C</div>
            </div>
            <div class="tongyongdiv">
              <div class="tips">温度上限</div>
              <div class="wendubox teshubox" style="margin:0px 10px">
                制冷固定
              </div>
              <div class="wendubox teshubox">制热固定</div>
            </div>
            <div class="tongyongdiv">
              <div class="tips">温度上限</div>
              <div class="mychecked">
                <el-checkbox v-model="suoding3"></el-checkbox>
              </div>
              <div class="miaoshu">锁定</div>
            </div>
          </div>
        </div>
        <div class="paging">
          <el-scrollbar style="height:calc(100% - 5px);width: 100%;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              background
              :current-page="currentPage"
              :page-sizes="[15]"
              :page-size="15"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filterText: "",
      treeDataList: [
        {
          stationName: getName(),
          id: "001",
          type: "jianzhu",
          ChildDatas: [
            {
              stationName: "照明管理",
              id: "101",
              type: "jianzhu",
              ChildDatas: [
                    {
                      stationName: "1楼",
                      id: "103",
                      type: "shebei",
                      ChildDatas: [],
                    },
                    {
                      stationName: "2楼",
                      id: "104",
                      type: "shebei",
                      ChildDatas: [],
                    },
                    {
                      stationName: "3楼",
                      id: "105",
                      type: "shebei",
                      ChildDatas: [],
                    },
                    {
                      stationName: "4楼",
                      id: "106",
                      type: "shebei",
                      ChildDatas: [],
                    },
                    {
                      stationName: "M楼",
                      id: "107",
                      type: "shebei",
                      ChildDatas: [],
                    },
                  ],
            },
          ],
        },
        {
          stationName: "空调管理",
          id: "002",
          type: "jianzhu",
          ChildDatas: [
                {
                  stationName: "1楼",
                  id: "202",
                  type: "shebei",
                  ChildDatas: [],
                },
                {
                  stationName: "2楼",
                  id: "203",
                  type: "shebei",
                  ChildDatas: [],
                },
                {
                  stationName: "3楼",
                  id: "204",
                  type: "shebei",
                  ChildDatas: [],
                },
                {
                  stationName: "4楼",
                  id: "205",
                  type: "shebei",
                  ChildDatas: [],
                },
                {
                  stationName: "M楼",
                  id: "206",
                  type: "shebei",
                  ChildDatas: [],
                },
              ],
        },
      ],
      defaultProps: {
        children: "ChildDatas",
        label: "stationName",
      },
      options: [
        {
          value: "选项1",
          label: "开机",
        },
        {
          value: "选项2",
          label: "故障",
        },
        {
          value: "选项3",
          label: "锁定",
        },
        {
          value: "选项4",
          label: "定时",
        },
        {
          value: "选项5",
          label: "未同步",
        },
        {
          value: "选项6",
          label: "离线",
        },
      ],
      valuename: "",
      searchName: "",
      currentPage: 1,
      total: 10,
      checked: false,
      percentage: 87,
      colors: [
        { color: "#409eff", percentage: 20 },
        { color: "#409eff", percentage: 40 },
        { color: "#409eff", percentage: 60 },
        { color: "#409eff", percentage: 80 },
        { color: "#409eff", percentage: 100 },
      ],
      middleData: [
        {
          name: "101",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "102",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "103",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "104",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "105",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "106",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "107",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "108",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "109",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "201",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "202",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "203",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "204",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "301",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
        {
          name: "302",
          shiwen: "27",
          kongwen: "25",
          checked: false,
        },
      ],
      value: false,
      value1: 16,
      value2: 31,
      value3: 5,
      isTreeShow: false,
      allchoice: false,
      suoding1: false,
      suoding2: false,
      suoding3: false,
      moshinum: 5,
      moshinumfeng: 4,
      active111: "",
    };
  },

  mounted() {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },

  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.stationName.includes(value);
    },
    topnodeClick() {},
    handleSizeChange() {},
    handleCurrentChange() {},
    //全选
    allchoicefn() {
      this.allchoice = !this.allchoice;
      this.middleData.forEach((item) => (item.checked = this.allchoice));
      if (this.allchoice) {
        this.isTreeShow = false;
      }
    },
    //
    clickCheckFn(row) {
      row.checked = !row.checked;
      if (row.checked) {
        this.isTreeShow = false;
      }
    },
    changCheck() {
      this.isTreeShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.controlpanel {
  width: 100%;
  height: 100%;

  .con {
    width: 100%;
    height: 100%;
    display: flex;

    .left-tree {
      width: 250px;
      height: 100%;
      background-color: #fff;
      margin-right: 8px;
      padding: 12px;
      box-sizing: border-box;
    }

    .right-con {
      width: calc(100% - 258px);
      height: 100%;
      background-color: #fff;
      padding: 12px;
      box-sizing: border-box;

      .topsearch {
        width: 100%;
        height: 36px;
        display: flex;
        margin-bottom: 8px;
      }

      .middlecon {
        width: 100%;
        height: calc(100% - 90px);
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        overflow: hidden;
        position: relative;

        .middlecard {
          width: calc(100% - 380px);
          height: 100%;
          display: flex;
          flex-wrap: wrap;
          margin-right: 22px;
          transition: 0.3s;

          &.middlecardactive {
            width: 100%;
          }

          .middlecarddiv {
            width: 100%;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
          }

          .carditem {
            width: 265px;
            height: 190px;
            border-color: rgb(153, 153, 153);
            position: relative;
            background-color: #cad8f3;
            margin-right: 8px;
            padding: 6px 16px;
            box-sizing: border-box;
            border-radius: 4px;
            margin-bottom: 8px;
            position: relative;

            .mymask {
              width: 100%;
              height: 100%;
              background-color: #000000;
              //  background-color: #efe9e9;
              z-index: 10;
              position: absolute;
              top: 0px;
              left: 0px;
              //  opacity: 0.5;
              opacity: 0.2;
            }

            .img1 {
              position: absolute;
              left: 4px;
              bottom: 4px;
            }

            .img2 {
              position: absolute;
              left: 4px;
              bottom: 4px;
            }

            .img3 {
              position: absolute;
              left: 50%;
              bottom: 0px;
              transform: translateX(-50%);
            }

            .img4 {
              position: absolute;
              right: 0px;
              top: 50%;
              transform: translateY(-50%);
            }

            .itemtop {
              color: black;
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              height: 30px;
              position: absolute;
              top: 0px;
              left: 0px;
              padding: 0px 16px;
              box-sizing: border-box;
              z-index: 20;

              &.topactive {
                background-color: #e9f3ff;
              }

              img {
                width: 18px;
                height: 18px;
              }

              /deep/.el-checkbox__label {
                color: black !important;
              }
            }

            .itemcon {
              width: 100%;
              height: calc(100% - 55px);
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 30px;

              .leftyibiaopan {
                width: 110px;
                height: 110px;
                position: relative;

                /deep/.el-progress-circle {
                  width: 110px !important;
                  height: 110px !important;
                }

                .context {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);

                  p {
                    font-size: 14px;
                    white-space: nowrap;
                  }

                  .num2 {
                    text-align: center;
                    font-size: 18px;

                    span {
                      font-size: 14px;
                    }
                  }
                }
              }

              .threeimg {
                //  width: calc(100% - 110px);
                height: 100%;
                display: flex;
                align-items: center;
                margin-left: 12px;

                .threeitem {
                  width: 96px;
                  height: 30px;
                  margin-bottom: 8px;
                  border-radius: 4px;
                  background-color: #a2baed;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  img {
                    width: 16px;
                    height: 16px;
                    margin-right: 5px;
                  }
                }
              }
            }

            .itembottom {
              display: flex;
              align-items: center;
              color: black;

              img {
                width: 18px;
                height: 18px;
                margin-right: 4px;
              }
            }
          }
        }

        .middledrawer {
          width: 345px;
          height: 100%;
          padding: 12px;
          box-sizing: border-box;
          border: 1px solid #409eff;
          border-radius: 4px;
          position: absolute;
          top: 0px;
          right: 0px;
          transition: 0.3s;

          &.draweractive {
            right: -344px;
          }

          .elescoping {
            position: absolute;
            top: 50%;
            left: -22px;
            transform: translateY(-50%);
            border: 1px solid #409eff;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            //   border-radius: 4px;
          }

          /deep/.el-slider__button {
            width: 9px;
            height: 9px;
          }

          .drawertitle {
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .leftname {
              font-size: 16px;
              display: flex;
              align-items: center;
            }

            .lines {
              display: inline-block;
              width: 4px;
              height: 16px;
              background-color: #368ed9;
              margin-right: 8px;
              border-radius: 4px;
            }

            .rightbtn {
              width: 58px;
              height: 28px;
              border-radius: 58px;
              background-color: #368ed9;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .zhenrigjt {
              display: flex;
              align-items: center;

              .jiesuo {
                background-color: #ffb522;
                margin-right: 8px;
              }
            }
          }

          .kaiguan {
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #1a1a1a;
            margin: 4px 0px;

            .wendunum {
              font-size: 26px;
              color: #409eff;

              span {
                font-size: 14px;
              }
            }

            .huakuai {
              width: 160px;
            }
          }

          .moshi {
            width: 100%;
            height: 74px;
            border-radius: 4px;
            display: flex;
            background-color: #a2baed;
            margin-bottom: 12px;

            .moshiitem {
              width: 25%;
              height: 74px;
              display: flex;
              align-items: center;
              justify-content: center;

              img {
                width: 28px;
                height: 28px;
                margin-bottom: 4px;
              }

              .zhireactive {
                color: rgb(255, 181, 34);
              }

              .zhilencative {
                color: rgb(36, 135, 255);
              }

              .chushiactive {
                color: rgb(141, 77, 231);
              }

              .songfengactive {
                color: rgb(92, 207, 225);
              }
            }
          }

          .fengsu {
            justify-content: space-between;

            .moshiitem {
              width: 33%;
            }
          }

          .tongyongdiv {
            display: flex;
            align-items: center;
            margin: 6px 0px;

            .tips {
              font-size: 14px;
              color: #1a1a1a;
            }

            .mychecked {
              margin: 0px 10px;
            }

            .huakuai {
              width: 120px;
              margin: 0px 10px;
            }

            .wendubox {
              width: 48px;
              height: 26px;
              background-color: #deeffe;
              border: 1px solid #368ed9;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #368ed9;
              border-radius: 4px;
            }

            .teshubox {
              width: 80px;
            }
          }
        }
      }

      .paging {
        display: flex;
        // margin-top: 10px;
        width: 100%;
        height: 36px;
      }
    }
  }
}
</style>
